import { ValidationVariable } from '../../enums/validation-task/validation-variable';
import { Guid } from '../guid';
import { IfRuleGroup } from '../if-gate/if-rule-group';

/**
 * A single field-level rule set for a Validation task. Evaluates an IfRuleGroup
 * against each record. failIfRuleMatches controls whether a rule match is a pass or fail.
 */
export class FieldRuleSet {
	/** UUID for this rule set. @default Guid() */
	id = Guid();

	/** Dot-notation path to the field being validated (used for logging). @default '' */
	fieldPath: string = '';

	/** The rule group to evaluate (same IfRuleGroup/IfRule structure as IfGate). */
	ruleGroup: IfRuleGroup = new IfRuleGroup();

	/**
	 * When false (default): record fails if the ruleGroup evaluates to a match (error condition).
	 * When true: record PASSES if the ruleGroup matches; fails if it does NOT match (required condition).
	 * @default false
	 */
	failIfRuleMatches = false;

	/**
	 * UI-only property. Not used at runtime.
	 * @default true
	 */
	isInSchema = true;

	validationVariable?: ValidationVariable;

	constructor(init?: Partial<FieldRuleSet>) {
		if (init) {
			Object.assign(this, init);
		}
		if (!this.id) {
			this.id = Guid();
		}
	}
}
